"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var MerkleTree = /** @class */ (function () {
    function MerkleTree(elements) {
        elements.sort();
        elements = MerkleTree.deduplicateSortedElements(elements);
        this.bufferElementPositionIndex = elements.reduce(function (memo, el, index) {
            memo[el] = index;
            return memo;
        }, {});
        this.layers = this.getLayers(elements);
    }
    MerkleTree.prototype.getLayers = function (elements) {
        if (elements.length === 0) {
            throw new Error('empty tree');
        }
        var layers = [];
        layers.push(elements);
        // Get next layer until we reach the root
        while (layers[layers.length - 1].length > 1) {
            layers.push(this.getNextLayer(layers[layers.length - 1]));
        }
        return layers;
    };
    MerkleTree.prototype.getNextLayer = function (elements) {
        return elements.reduce(function (layer, el, idx, arr) {
            if (idx % 2 === 0) {
                // Hash the current element with its pair element
                layer.push(MerkleTree.combinedHash(el, arr[idx + 1]));
            }
            return layer;
        }, []);
    };
    MerkleTree.combinedHash = function (first, second) {
        if (!first) {
            return second;
        }
        if (!second) {
            return first;
        }
        return ethers_1.utils.keccak256(MerkleTree.sortAndConcat(first, second));
    };
    MerkleTree.prototype.getRoot = function () {
        return this.layers[this.layers.length - 1][0];
    };
    MerkleTree.prototype.getHexRoot = function () {
        return this.getRoot();
    };
    MerkleTree.prototype.getProof = function (el) {
        var idx = this.bufferElementPositionIndex[el];
        if (typeof idx !== 'number') {
            throw new Error('Element does not exist in Merkle tree');
        }
        return this.layers.reduce(function (proof, layer) {
            var pairElement = MerkleTree.getPairElement(idx, layer);
            if (pairElement) {
                proof.push(pairElement);
            }
            idx = Math.floor(idx / 2);
            return proof;
        }, []);
    };
    MerkleTree.getPairElement = function (idx, layer) {
        var pairIdx = idx % 2 === 0 ? idx + 1 : idx - 1;
        if (pairIdx < layer.length) {
            return layer[pairIdx];
        }
        else {
            return null;
        }
    };
    MerkleTree.deduplicateSortedElements = function (elements) {
        return elements.filter(function (el, idx) {
            return idx === 0 || !(elements[idx - 1] === el);
        });
    };
    MerkleTree.sortAndConcat = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var sortedArgs = __spreadArrays(args).map(function (value) { return value.substr(2); }).sort();
        return '0x'.concat.apply('0x', sortedArgs);
    };
    return MerkleTree;
}());
exports.default = MerkleTree;
